"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _usePermissions2 = _interopRequireDefault(require("./usePermissions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Permissions = function Permissions(_ref) {
  var displayWhen = _ref.displayWhen,
      children = _ref.children;

  var _usePermissions = (0, _usePermissions2["default"])(),
      enableWithRoles = _usePermissions.enableWithRoles;

  var render = enableWithRoles(displayWhen);
  return render ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children) : null;
};

var _default = Permissions;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9QZXJtaXNzaW9ucy50c3giXSwibmFtZXMiOlsiUGVybWlzc2lvbnMiLCJkaXNwbGF5V2hlbiIsImNoaWxkcmVuIiwiZW5hYmxlV2l0aFJvbGVzIiwicmVuZGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFRQSxJQUFNQSxXQUFpQyxHQUFHLFNBQXBDQSxXQUFvQyxPQUErQjtBQUFBLE1BQTVCQyxXQUE0QixRQUE1QkEsV0FBNEI7QUFBQSxNQUFmQyxRQUFlLFFBQWZBLFFBQWU7O0FBQUEsd0JBQzNDLGtDQUQyQztBQUFBLE1BQy9EQyxlQUQrRCxtQkFDL0RBLGVBRCtEOztBQUV2RSxNQUFNQyxNQUFNLEdBQUdELGVBQWUsQ0FBQ0YsV0FBRCxDQUE5QjtBQUNBLFNBQU9HLE1BQU0sZ0JBQUcsa0VBQUdGLFFBQUgsQ0FBSCxHQUFxQixJQUFsQztBQUNELENBSkQ7O2VBTWVGLFciLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgRkMsIFJlYWN0Tm9kZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB1c2VQZXJtaXNzaW9ucyBmcm9tICcuL3VzZVBlcm1pc3Npb25zJztcbmltcG9ydCB7IFJvbGVzIH0gZnJvbSAnLi9QZXJtaXNzaW9uc0NvbnRleHQnO1xuXG50eXBlIFBlcm1pc3Npb25zUHJvcHMgPSB7XG4gIGRpc3BsYXlXaGVuOiBSb2xlc1tdO1xuICBjaGlsZHJlbjogUmVhY3ROb2RlO1xufTtcblxuY29uc3QgUGVybWlzc2lvbnM6IEZDPFBlcm1pc3Npb25zUHJvcHM+ID0gKHsgZGlzcGxheVdoZW4sIGNoaWxkcmVuIH0pID0+IHtcbiAgY29uc3QgeyBlbmFibGVXaXRoUm9sZXMgfSA9IHVzZVBlcm1pc3Npb25zKCk7XG4gIGNvbnN0IHJlbmRlciA9IGVuYWJsZVdpdGhSb2xlcyhkaXNwbGF5V2hlbik7XG4gIHJldHVybiByZW5kZXIgPyA8PntjaGlsZHJlbn08Lz4gOiBudWxsO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgUGVybWlzc2lvbnM7XG4iXX0=